import type { ReactNode } from "react";
import { cn } from "@/lib/utils";
import MapPinIcon from "@heroicons/react/24/solid/MapPinIcon";
import XMarkIcon from "@heroicons/react/24/solid/XMarkIcon";
import {
  QuoteDropdown,
  QuoteInput,
  QuoteMain,
} from "@/components/views/quote-venue/steps/select-screen/custom-autocomplete/QuoteMain";

interface Mutations {
  handleFocus: (event) => void;
  setQuery: (query: string) => void;
  setInputIsFocused: (isFocused: boolean) => void;
  setSelectedData: (data: any) => void;
}

interface Props extends Mutations {
  id: string;
  parentId: string;
  label: string;
  inputIsFocused: boolean;
  selectedData: any;
  query: string;
  data: any;
  footer?: ReactNode;
}

export default function QuoteCustomAutoComplete(props: Props) {
  const {
    id,
    parentId,
    label,
    inputIsFocused,
    selectedData,
    setInputIsFocused,
    setSelectedData,
    handleFocus,
    data,
    query,
    setQuery,
    footer,
  } = props;
  return (
    <div
      className={cn(
        `${inputIsFocused ? "max-md:fixed max-md:inset-0 max-md:bg-white h-screen md:h-[56px] z-[99]" : ""}`,
      )}
    >
      <div className="fixed z-50 right-4 top-6 flex justify-end items-center w-full">
        <button
          onClick={() => setInputIsFocused(false)}
          className={inputIsFocused ? "max-md:flex hidden bg-white" : "hidden"}
        >
          <XMarkIcon className="size-8 text-assistant" />
        </button>
      </div>

      <QuoteMain
        className={
          inputIsFocused
            ? "max-md:translate-x-[23px] max-md:!w-[calc(100%-46px)] max-md:!fixed max-md:z-[99] max-md:top-[64px] max-md:duration-200"
            : "duration-200"
        }
        setSelectedData={setSelectedData}
        selectedData={selectedData}
        icon={MapPinIcon}
        isFocused={inputIsFocused}
        closeDropdown={() => setInputIsFocused(false)}
      >
        <QuoteInput
          id={id}
          parentId={parentId}
          isFocusedColor="rose-500"
          label={label}
          query={query}
          onFocus={(event) => handleFocus(event)}
          onChange={(e) => {
            setQuery(e.target.value);
          }}
        />

        <QuoteDropdown
          onClose={() => {
            setInputIsFocused(false);
          }}
          items={data}
          footer={footer}
        />
      </QuoteMain>
    </div>
  );
}
